import React, {useCallback} from 'react';
import { connect } from "react-redux";
import {getStepFromPosition} from './getStepFromPosition.js';
import {INFO_COLUMN_WIDTH} from './constants.js';
import {getScrollLeft} from './getScrollLeft.js';
import Step from 'components/track/Step.js';
import {DEFAULT_RESOLUTION} from './constants.js';
import {ARRANGEMENT_TRACK_PATTERN} from 'session/constants.js';
import {
    setArrangementCursorStep,
    setArrangementMouseX,
    setArrangementPatternDragging,
    setArrangementPatternResizing,
    setSelectedArrangementEvents,
    setArrangementBottomMode}  from 'actions/index.js';
import {getBarWidth} from './getBarWidth.js';
import {PIANO_ROLL} from 'constants/arrangement-modes.js';
import Colors from 'components/Colors.js';
import {LEFT, RIGHT} from './constants.js';

const colors = new Colors();

function PatternRoll(props) {
    let length = props.pattern.length(props.resolution);

    let steps = props.steps === undefined ? [] :
        props.steps.map((s, i) => ({
        stepNumber: i,
        on: s,
    }))
        .filter(s => s.on);

    const startDragging = useCallback((e) => {
        e.stopPropagation();
        let left = getBarWidth(props.startStep, props.resolution, props.xScale);
        let offset = e.pageX + getScrollLeft() - left - INFO_COLUMN_WIDTH;
        props.setPatternDragging(props.pattern, offset);

        let selectedEvents = {};
        selectedEvents[ARRANGEMENT_TRACK_PATTERN] = props.pattern;
        props.setSelectedEvents(selectedEvents);
        props.track.switchToPattern(props.patternNumber);
        props.track.updateSteps(true);
        if (props.sequencerEngine.state.arrangement.bottomMode !== PIANO_ROLL &&
            props.isSelected) {
            props.setArrangementMode(PIANO_ROLL);
        }
        props.setArrangementMouseX(undefined);
        props.setArrangementCursorStep(undefined);
    }, [
        props.setArrangementMode,
        props.startStep,
        props.patternNumber,
        props.setPatternDragging,
        props.isSelected,
        props.pattern,
        props.xScale]);

    const onMouseUp = useCallback((e) => {
        e.stopPropagation();
        props.setPatternDragging(undefined);
        props.setPatternResizing(undefined);
    }, [props.setPatternDragging], props.setPatternResizing);

    const onEdgeMouseDown = useCallback((e, direction) => {
        e.stopPropagation();
        props.setPatternResizing(props.pattern, direction);
    }, [props.setPatternResizing, props.pattern]);

    // style
    let style = {
        backgroundColor: colors.getColorForHash(props.track.presetName || props.track.getName())
    };
    
    style.width = getBarWidth(
        props.pattern.length(),
        props.resolution,
        props.xScale);

    let fullStyle = {
        width: style.width,
        left: getBarWidth(props.startStep, props.resolution, props.xScale)
    };

    let className = "mini-piano-roll-wrapper";
    fullStyle['border'] = '1px solid ' + colors.brighten(style.backgroundColor, 0.3);
    if (props.isSelected) {
        fullStyle['border'] = '1px solid ' + style.backgroundColor;
        fullStyle['backgroundColor'] = colors.brighten(style.backgroundColor, 0.3);
        fullStyle['opacity'] = 0.7;
    }

    style.width -= 1;

    return (
        <div
          onMouseUp={() => props.setPatternDragging(undefined)}
          style={fullStyle}
          className={className}>
          <div
            onMouseDown={startDragging}
            onMouseUp={onMouseUp}
            style={style} className="mini-piano-roll-header">
            <div
              onMouseDown={(e) => onEdgeMouseDown(e, LEFT)}
              className="left-edge"></div>
            <div className="middle"></div>
            <div
              onMouseDown={(e) => onEdgeMouseDown(e, RIGHT)}
              className="right-edge"></div>
          </div>
          <div className="mini-piano-roll steps-map">
            {steps.map(
                (x, i) =>
                    <Step
                          pattern={props.pattern}
                          width={length * getBarWidth(2, props.resolution, props.xScale)}
                          height={60}
                          key={'mini-step-' + i + '-' + x.stepNumber}
                          trackColor={"#00ff14"}
                          length={length}
                          track={props.track}
                          stepNumber={x.stepNumber}
                          resolution={props.resolution}
                          stepData={x.step}/>
            )}
        
        </div>
        </div>
    );
}

const mapStateToProps = (state, props) => {
    let steps = state.tracks.trackPatternSteps[props.track.subSequence.id] || {};

    let selectedEvents = state.arrangement.selectedEvents;
    let isSelected = selectedEvents === undefined ?
            false :
        selectedEvents[ARRANGEMENT_TRACK_PATTERN] === props.pattern;
    let patternStartStep = state.arrangement.patternStartSteps[props.track.subSequence.id];
    return {
        isSelected: isSelected,
        resolution: DEFAULT_RESOLUTION,
        steps: steps[props.patternNumber],
        xScale: state.arrangement.xScale,
        startStep: patternStartStep ? patternStartStep[props.pattern.id] : 0,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setSelectedEvents: (events) => dispatch(
            setSelectedArrangementEvents(events)),
        setArrangementMode: (mode) => dispatch(setArrangementBottomMode(mode)),
        setPatternDragging: (pattern, offset) => dispatch(setArrangementPatternDragging(pattern, offset)),
        setPatternResizing: (pattern, resizing) => dispatch(setArrangementPatternResizing(pattern, resizing)),
        setArrangementMouseX: (mouseX) => dispatch(setArrangementMouseX(mouseX)),
        setArrangementCursorStep: (x) => dispatch(
            setArrangementCursorStep(x)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PatternRoll);

